import React from 'react';
import styles from '../style/Blog.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetBlogsQuery } from '../redux/api';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

const Blog = ({ isSection = false }) => {
    const navigate = useNavigate();
    const { page } = useParams();
    const currentPage = parseInt(page) || 1;
    const { data } = useGetBlogsQuery(currentPage);

    const blogs = Array.isArray(data) ? data : (data?.blogs || []);
    const displayData = isSection ? blogs.slice(0, 4) : blogs;
    const totalPages = data?.totalPages || Math.ceil(blogs.length / 4);

    const isActuallySection = isSection === true || isSection === "true" || Boolean(isSection);

    return (
        <section className={styles.blogSection}>
            {!isActuallySection && (
                <SEO
                    title="SEO & Digital Marketing Blog"
                    description="Read the latest blog posts and articles from CreaTech Squads on SEO, digital marketing, web development trends, and business growth strategies in India."
                    keywords="SEO company in India, Digital Marketing company, Website Development, ERP Solutions, CRM Development, Cyber Security Services, IT Company India, digital marketing blog India, SEO tips, web development articles, IT company blog"
                    canonical="/blogs"
                    breadcrumbs={[
                        { name: "Home", item: "/" },
                        { name: "Blog", item: "/blogs" }
                    ]}
                />
            )}
            <div className={styles.container}>
                <motion.div 
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                    className={styles.header}
                >
                    <h2 className={styles.title}>Our Latest <br /><span>Blog & Article</span></h2>
                    <p className={styles.subtitle}>Explore our latest blog and articles for insights on web design, SEO, and digital trends.</p>
                </motion.div>

                <div className={styles.grid}>
                    {displayData?.map((post, index) => (
                        <motion.article
                            initial={{ opacity: 0, x: 50, y: 30 }}
                            whileInView={{ opacity: 1, x: 0, y: 0 }}
                            viewport={{ once: true, margin: "0px 0px -150px 0px" }}
                            transition={{ duration: 0.8, delay: index * 0.15, type: "spring", bounce: 0.4 }}
                            onClick={() => navigate(`/blog/${post.slug}`)}
                            key={post._id}
                            className={styles.card}
                            style={{
                                position: 'sticky',
                                top: `${100 + index * 40}px`, // Stacking offset
                                zIndex: index + 1
                            }}
                        >
                            <div className={styles.imageWrapper}>
                                <img
                                    src={post.images?.[0] ? `${process.env.REACT_APP_API_URL || "https://api.createchsquads.com"}/${post.images[0].replace(/\\/g, "/")}` : "/assets/placeholder.png"}
                                    alt={post.title}
                                    className={styles.image}
                                />
                            </div>

                            <div className={styles.content}>
                                <h3 className={styles.cardTitle}>{post.title}</h3>

                                <p className={styles.cardExcerpt}>
                                    {post.shortDescription}
                                </p>

                                <div className={styles.meta}>
                                    <span className={styles.date}>
                                        {new Date(post.createdAt).toLocaleDateString()}
                                    </span>

                                    <span className={styles.separator}>/</span>

                                    <span className={styles.author}>
                                        BY {post.authorName}
                                    </span>
                                </div>
                            </div>
                        </motion.article>
                    ))}
                </div>
            </div>

            {blogs && blogs.length > 0 && (
                <motion.div 
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                    className={styles.paginationArea}
                >
                    {isSection ? (
                        <motion.button 
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className={styles.allBtn} 
                            onClick={() => navigate('/blogs')}
                        >
                            View All Blogs
                        </motion.button>
                    ) : (
                        totalPages > 1 && (
                            <motion.div 
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.4 }}
                                className={styles.paginationControls}
                            >
                                <motion.button 
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    disabled={currentPage === 1} 
                                    onClick={() => navigate(`/blogs/${currentPage - 1}`)}
                                    className={styles.pageBtn}
                                >Previous</motion.button>
                                
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map(pageNum => (
                                    <motion.button 
                                        whileHover={{ scale: 1.1 }}
                                        whileTap={{ scale: 0.9 }}
                                        key={pageNum} 
                                        onClick={() => navigate(`/blogs/${pageNum}`)}
                                        className={`${styles.pageBtn} ${currentPage === pageNum ? styles.activePage : ''}`}
                                    >
                                        {pageNum}
                                    </motion.button>
                                ))}

                                <motion.button 
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    disabled={currentPage === totalPages} 
                                    onClick={() => navigate(`/blogs/${currentPage + 1}`)}
                                    className={styles.pageBtn}
                                >Next</motion.button>
                            </motion.div>
                        )
                    )}
                </motion.div>
            )}
        </section>
    );
};

export default Blog;
